'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useDefaultBreakpoint } from '@/ui/hooks/create-break-point';
import { cn } from '@/utils/css-class';
import type { GalleryContentProps } from '@/services/sanity';
type MediaProps = {
  item: GalleryContentProps;
  isLoaded: boolean;
  onLoad: () => void;
  onOpenModal: () => void;
};
export default function Media(t0) {
  const $ = _c(38);
  const {
    item,
    isLoaded,
    onLoad,
    onOpenModal
  } = t0;
  const {
    mediaType,
    image,
    video,
    title,
    brainRegion
  } = item;
  const mediaUrl = mediaType === "video" ? video : image;
  const breakpoint = useDefaultBreakpoint();
  const isDesktop = breakpoint === "l" || breakpoint === "xl";
  if (!mediaUrl) {
    return null;
  }
  const t1 = title || "Gallery media";
  const t2 = item.has_background && item.backgroundColor ? item.backgroundColor : undefined;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      backgroundColor: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isLoaded) {
    t4 = !isLoaded && <div className="absolute inset-0 animate-pulse bg-gray-200" style={{
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }} />;
    $[2] = isLoaded;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== image || $[5] !== isLoaded || $[6] !== mediaType || $[7] !== onLoad || $[8] !== title || $[9] !== video) {
    t5 = mediaType === "video" ? <video src={video || ""} className={`h-full w-full object-cover transition-opacity duration-300 ${isLoaded ? "opacity-100" : "opacity-0"}`} onLoadedData={onLoad} muted={true} playsInline={true}><track kind="captions" /></video> : <Image src={image || ""} alt={title || "Gallery image"} fill={true} className={cn("object-cover transition-opacity duration-300", isLoaded ? "opacity-100" : "opacity-0")} onLoad={onLoad} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw" />;
    $[4] = image;
    $[5] = isLoaded;
    $[6] = mediaType;
    $[7] = onLoad;
    $[8] = title;
    $[9] = video;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onOpenModal || $[12] !== t1 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <button type="button" data-testid="gallery-media-item" onClick={onOpenModal} aria-label={t1} className="border-neutral-2 relative mb-3 aspect-square w-full cursor-pointer overflow-hidden rounded-lg border border-solid" style={t3}>{t4}{t5}</button>;
    $[11] = onOpenModal;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isDesktop || $[18] !== title) {
    t7 = !isDesktop && title && title.length > 22 ? {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "100%"
    } : undefined;
    $[17] = isDesktop;
    $[18] = title;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = !isDesktop && title && title.length > 22 ? title : undefined;
  let t9;
  if ($[20] !== isDesktop || $[21] !== title) {
    t9 = !isDesktop && title && title.length > 22 ? `${title.substring(0, 22)}...` : title;
    $[20] = isDesktop;
    $[21] = title;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <div className="text-base font-semibold" style={t7} title={t8}>{t9}</div>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== brainRegion) {
    t11 = brainRegion && <div className="text-sm font-normal capitalize"><span className="text-neutral-4">Brain Region:</span> {brainRegion}</div>;
    $[27] = brainRegion;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== isDesktop) {
    t12 = isDesktop && <div className="text-sm font-normal">Copyright OBI – {new Date().getFullYear()}</div>;
    $[29] = isDesktop;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t12) {
    t13 = <aside className="flex flex-col">{t10}{t11}{t12}</aside>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t13 || $[36] !== t6) {
    t14 = <div className="flex flex-col">{t6}{t13}</div>;
    $[35] = t13;
    $[36] = t6;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}